/*!
 * jQuery Checky - A Checkbox Restrictor
 *
 * The MIT License
 *
 * @author: Washington Botelho
 * @doc: github.com/wbotelhos/checky
 * @version: 0.1.0
 *
 */

// done
function Checky(element, options) {
  'use strict';

  this.element = element;
  this.self = $(element);
  this.opt = $.extend(true, {}, $.fn.checkony.defaults, options);

  this.items = this.self.find(this.opt.item);
  this.total = this.items.length;
  this.checkeds = [];
}

// done
Checky.prototype._addInitials = function () {
  'use strict';

  var that = this;

  this._checkeds().each(function () {
    that.checkeds.push(this);
  });
};

// done
Checky.prototype._addOrRemove = function (item) {
  'use strict';

  if (item.checked) {
    this.checkeds.push(item);
  } else {
    var index = this.checkeds.indexOf(item);

    if (index >= 0) {
      this.checkeds.splice(index, 1);
    }
  }
};

// done
Checky.prototype._bindItems = function () {
  'use strict';

  var that = this;

  that.items.on('change', function () {
    if (that.opt.type === 'radio') {
      that._clean(this);
    } else {
      that._addOrRemove(this);
      that._inspect();
    }
  });
};

// done
Checky.prototype._clean = function (item) {
  'use strict';

  var inputs = this.items.filter(function () {
    return this !== item;
  });

  for (const input of inputs) {
    input.checked = false;
  }
};

// done
Checky.prototype._configure = function () {
  if (this.opt.type === 'radio') {
    this.opt.min = 0;
    this.opt.max = 1;
  }
};

// done
Checky.prototype._create = function () {
  'use strict';

  this._configure();
  this._bindItems();

  if (this.opt.type !== 'radio') {
    this._addInitials();
    this._inspect();
  }
};

// done
Checky.prototype._checkeds = function () {
  'use strict';

  return this.items.filter(':checked');
};

// done
Checky.prototype._max = function () {
  'use strict';

  return this.opt.max && this._checkeds().length > this.opt.max;
};

// done
Checky.prototype._min = function () {
  'use strict';

  return this.opt.min && this._checkeds().length < this.opt.min;
};

// done
Checky.prototype._select = function (item) {
  'use strict';

  item.checked = true;

  this.checkeds.push(item);
};

// done
Checky.prototype._inspect = function () {
  'use strict';

  if (this._max()) {
    this._unselect();
  } else if (this._min()) {
    var uncheckeds = this._uncheckeds();

    for (var i = 0; i < this._toSelect(); i++) {
      this._select(uncheckeds[i]);
    }
  }
};

// done
Checky.prototype._toSelect = function () {
  'use strict';

  if (!this.opt.min) {
    return 0;
  }

  return this.opt.min - this._checkeds().length;
};

// done
Checky.prototype._uncheckeds = function () {
  'use strict';

  return this.items.filter(':not(:checked)');
};

// done
Checky.prototype._unselect = function () {
  'use strict';

  var item = this.checkeds.shift();

  item.checked = false;
};

(function ($) {
  'use strict';

  // done
  $.fn.checkony = function (options) {
    var args = Array.prototype.slice.call(arguments, 1),
      method = Checky.prototype[options];

    return this.each(function () {
      var self = $(this),
        instance = self.data('checkony');

      if (!instance) {
        instance = new Checky(this, options);

        instance._create();

        self.data('checkony', instance);
      }

      if (method) {
        method.apply(instance, args);
      } else if (options && typeof options !== 'object') {
        $.error('Method ' + options + ' does not exist!');
      }
    });
  };

  // done
  $.fn.checkony.defaults = {
    item: '.checkony',
    max: undefined,
    min: undefined,
    type: 'checkbox',
  };
})(jQuery);
